import { render, staticRenderFns } from "./OrganisationHeader.vue?vue&type=template&id=b59b0880&scoped=true"
import script from "./OrganisationHeader.vue?vue&type=script&lang=ts"
export * from "./OrganisationHeader.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationHeader.vue?vue&type=style&index=0&id=b59b0880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59b0880",
  null
  
)

export default component.exports